// extracted by mini-css-extract-plugin
export default {"conteiner":"About_conteiner__v81N2","social":"About_social__ptss2","globo":"About_globo__Yg55c","texto":"About_texto__vEqga"};